import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchPayrollCategoriesRequest,
  FetchPayrollCategoryByIdRequest,
  FetchAllPayrollCategoriesRequest,
  CreatePayrollCategoryRequest,
  UpdatePayrollCategoryRequest,
  DeletePayrollCategoryRequest,
  SuspendPayrollCategoryRequest,
  ActivatePayrollCategoryRequest,
} from './types'
import {AxiosError} from 'axios'
import axios from 'axios'
import {setupAxios} from '../../setup-axios'
import {
  fetchPayrollCategoriesUrl,
  fetchPayrollCategoryByIdUrl,
  fetchAllPayrollCategoriesUrl,
  createPayrollCategoryUrl,
  updatePayrollCategoryUrl,
  deletePayrollCategoryUrl,
  suspendPayrollCategoryUrl,
  activatePayrollCategoryUrl,
} from '../../api'

setupAxios(axios)

export const fetchPayrollCategories = createAsyncThunk(
  'payrollCategory/fetch',
  async (payload: FetchPayrollCategoriesRequest, {rejectWithValue}) => {
    try {
      const params = new URLSearchParams()
      if (payload.search) params.append('search', payload.search)
      if (payload.sortField) params.append('sortField', payload.sortField)
      if (payload.sortOrder) params.append('sortOrder', payload.sortOrder)
      if (payload.pageNumber) params.append('pageNumber', payload.pageNumber.toString())
      if (payload.pageCount) params.append('pageCount', payload.pageCount.toString())

      const res = await axios.get(`${fetchPayrollCategoriesUrl}?${params.toString()}`)
      const {payrollCategories, total, totalPages} = res.data
      return {
        payrollCategories,
        total,
        totalPages,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to fetch payroll categories'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const fetchAllPayrollCategories = createAsyncThunk(
  'payrollCategory/fetchAll',
  async (payload: FetchAllPayrollCategoriesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(fetchAllPayrollCategoriesUrl)
      const {payrollCategories} = res.data
      return {
        payrollCategories,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to fetch payroll categories'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const fetchPayrollCategoryById = createAsyncThunk(
  'payrollCategory/fetchById',
  async (payload: FetchPayrollCategoryByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(fetchPayrollCategoryByIdUrl(payload.id))
      const {payrollCategory} = res.data
      return {
        payrollCategory,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to fetch payroll category'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const createPayrollCategory = createAsyncThunk(
  'payrollCategory/create',
  async (payload: CreatePayrollCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createPayrollCategoryUrl, payload)
      const {payrollCategory} = res.data
      return {
        payrollCategory,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to create payroll category'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const updatePayrollCategory = createAsyncThunk(
  'payrollCategory/update',
  async (payload: UpdatePayrollCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updatePayrollCategoryUrl, payload)
      const {payrollCategory} = res.data
      return {
        payrollCategory,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to update payroll category'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const deletePayrollCategory = createAsyncThunk(
  'payrollCategory/delete',
  async (payload: DeletePayrollCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deletePayrollCategoryUrl, {id: payload.id})
      const {payrollCategory} = res.data
      return {
        payrollCategory,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to delete payroll category'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const suspendPayrollCategory = createAsyncThunk(
  'payrollCategory/suspend',
  async (payload: SuspendPayrollCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendPayrollCategoryUrl, {id: payload.id})
      const {payrollCategory} = res.data
      return {
        payrollCategory,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to suspend payroll category'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

export const activatePayrollCategory = createAsyncThunk(
  'payrollCategory/activate',
  async (payload: ActivatePayrollCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activatePayrollCategoryUrl, {id: payload.id})
      const {payrollCategory} = res.data
      return {
        payrollCategory,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.message?.fr || err.response?.data?.message?.en || 'Failed to activate payroll category'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

